import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../../../../shared/LanguageService';

type NoAvailableTimeslotsProps = {
    photographerName: string;
};

export function NoAvailableTimeslots({ photographerName }: NoAvailableTimeslotsProps) {
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography
                variant="body1"
                sx={{
                    fontSize: '18px',
                    fontFamily: 'Roboto',
                    color: 'text.secondary',
                    textAlign: 'center',
                    padding: '20px 0'
                }}
            >
                {Translate(
                    'orders/list/bookings-calendar/no-available-timeslots-for-photographer',
                    {
                        chosenPhotographer: photographerName
                    }
                )}
            </Typography>
        </Box>
    );
}
